export default __webpack_public_path__ + "static/media/next-airlockz.8f08faa0.jpg";